import React from 'react'
import Event from './Aavartan_Components/Event'
import Navbar from './Home/Navbar-new/Navbar'

const EventPage = () => {
  return (
    <>
    <Navbar/>
    <Event/>
    </>
  )
}

export default EventPage